/**
 * Schedule API Contracts
 *
 * Schedule and calendar endpoints.
 */

// Common types and entity re-exports
export * from './common'

// Meeting endpoints (list, daily, section, faculty)
export * from './meetings'

// User schedule endpoints (mobile-focused)
export * from './user-schedule'
